export default {
  data() {
    return {
      isDragOver: false,
      dragCounter: 0,
    };
  },
  emits: ["droppedMovableItems"],
  methods: {
    onDragEnter(event) {
      if (event.dataTransfer.types.includes('text/x-tw-movable-item')) {
        this.dragCounter++;
        this.isDragOver = true;
        // console.log('Drag Enter detected for pod item.');
      }
    },
    onDragLeave(event) {
      if (event.dataTransfer.types.includes('text/x-tw-movable-item')) {
        this.dragCounter--;
        if (this.dragCounter === 0) {
          this.isDragOver = false;
        }
      }
    },
    handleDomDragOver(event) {
      if (event.dataTransfer.types.includes('text/x-tw-movable-item')) {
        event.dataTransfer.dropEffect = 'move';
      }
      // console.log('handleDomDragOver called with:', param1, param2, param3);
    },
    handleDomDrop(event) {
      this.isDragOver = false;
      this.dragCounter = 0;

      if (!event.dataTransfer.types.includes('text/x-tw-movable-item')) {
        return;
      }

      const targetNode = this.item || this.node;

      const data = {
        targetNodeId: targetNode.id,
        nodeIds: JSON.parse(event.dataTransfer.getData('text/x-tw-movable-nodes')),
        podIds: JSON.parse(event.dataTransfer.getData('text/x-tw-movable-pods')),
      };

      if (data.nodeIds.includes(data.targetNodeId)) {
        // cannot drop the selected item into itself
        return;
      }

      // console.log("Dropped items", event);
      // console.log("Emitting data", data);
      this.$emit("droppedMovableItems", data);
      // console.log('handleDomDrop called with:', param1, param2, param3);
    }
  }
}
